var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotDrinkingWater(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#not-drinking-water_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.317 8.225a2.226 2.226 0 002.772 1.497 2.228 2.228 0 001.497-2.772l-.913-3.055a2.228 2.228 0 00-4.27 1.275l.914 3.055zM7.551 33.79l-3.134.775a2.228 2.228 0 101.071 4.325l3.134-.776a2.227 2.227 0 10-1.07-4.325zM35.706 9.911a2.228 2.228 0 002.728-1.575L39.3 5.11a2.228 2.228 0 10-4.303-1.154l-.865 3.228a2.228 2.228 0 001.575 2.728zM10.334 24.56a2.228 2.228 0 00-1.576-2.728l-3.227-.865a2.228 2.228 0 10-1.153 4.304l3.227.865a2.228 2.228 0 002.729-1.576zM25.11 41.738a13.26 13.26 0 01-.35-.16c-5.607-2.678-8.507-8.986-6.896-15 1.659-6.19 7.697-10.267 14.046-9.483.157.02.316.043.474.068a2.228 2.228 0 00.71-4.399 17.365 17.365 0 00-12.408 2.715 17.36 17.36 0 00-7.126 9.947c-2.166 8.086 1.736 16.57 9.28 20.172.154.073.313.146.47.216a2.228 2.228 0 001.8-4.076zM16.014 11.513l-2.223-2.21a2.228 2.228 0 00-3.142 3.16l2.223 2.21a2.228 2.228 0 103.141-3.16zM15.127 44.149a2.228 2.228 0 00-3.15-.015l-2.295 2.272a2.228 2.228 0 003.136 3.166l2.294-2.273c.874-.866.88-2.276.015-3.15z",
    fill: "#31576D"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#not-drinking-water_svg__clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.825 24.639c.222 0 .407.119.518.238.11.159.185.397.148.595L51.198 57.75c-.037.357-.333.635-.666.635h-17.17c-.334 0-.63-.278-.667-.635l-4.293-32.277a.8.8 0 01.148-.595.708.708 0 01.518-.238h25.757z",
    stroke: "#31576D",
    strokeWidth: 4.5,
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "not-drinking-water_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h59.286v60H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "not-drinking-water_svg__clip1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(25 21)",
    d: "M0 0h34v39H0z"
  })))));
}

export default SvgNotDrinkingWater;